/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  BookmarkStatus,
  CheckBookmarkParams,
  ListBookmarksParams,
  PaginatedBookmarks,
  SchemaValidationErrorResponse,
  ToggleBookmarkParams
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Bookmarks
 */
export const listBookmarks = (
    params?: MaybeRefOrGetter<ListBookmarksParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedBookmarks>(
      {url: `/bookmarks`, method: 'GET',
        params, signal
    },
      );
    }




export const getListBookmarksQueryKey = (params?: MaybeRefOrGetter<ListBookmarksParams>,) => {
    return [
    'bookmarks', ...(params ? [params] : [])
    ] as const;
    }


export const getListBookmarksQueryOptions = <TData = Awaited<ReturnType<typeof listBookmarks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListBookmarksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListBookmarksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBookmarks>>> = ({ signal }) => listBookmarks(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData>
}

export type ListBookmarksQueryResult = NonNullable<Awaited<ReturnType<typeof listBookmarks>>>
export type ListBookmarksQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Bookmarks
 */

export function useListBookmarks<TData = Awaited<ReturnType<typeof listBookmarks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListBookmarksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBookmarksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Check Bookmark Status
 */
export const checkBookmark = (
    params: MaybeRefOrGetter<CheckBookmarkParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<BookmarkStatus>(
      {url: `/bookmarks/check`, method: 'GET',
        params, signal
    },
      );
    }




export const getCheckBookmarkQueryKey = (params?: MaybeRefOrGetter<CheckBookmarkParams>,) => {
    return [
    'bookmarks','check', ...(params ? [params] : [])
    ] as const;
    }


export const getCheckBookmarkQueryOptions = <TData = Awaited<ReturnType<typeof checkBookmark>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params: MaybeRefOrGetter<CheckBookmarkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCheckBookmarkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkBookmark>>> = ({ signal }) => checkBookmark(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData>
}

export type CheckBookmarkQueryResult = NonNullable<Awaited<ReturnType<typeof checkBookmark>>>
export type CheckBookmarkQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Check Bookmark Status
 */

export function useCheckBookmark<TData = Awaited<ReturnType<typeof checkBookmark>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params: MaybeRefOrGetter<CheckBookmarkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckBookmarkQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Toggle Bookmark
 */
export const toggleBookmark = (
    params: MaybeRefOrGetter<ToggleBookmarkParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<BookmarkStatus>(
      {url: `/bookmarks/toggle`, method: 'POST',
        params, signal
    },
      );
    }




export const getToggleBookmarkMutationKey = () => ['toggleBookmark'] as const;

export const getToggleBookmarkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,ToggleBookmarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,ToggleBookmarkMutationVariables, TContext> => {

const mutationKey = getToggleBookmarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleBookmark>>, ToggleBookmarkMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  toggleBookmark(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof toggleBookmark>>>

    export type ToggleBookmarkMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ToggleBookmarkMutationVariables = {params: ToggleBookmarkParams}

    /**
 * @summary Toggle Bookmark
 */
export const useToggleBookmark = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,ToggleBookmarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleBookmark>>,
        TError,
        ToggleBookmarkMutationVariables,
        TContext
      > => {
      return useMutation(getToggleBookmarkMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Bookmark
 */
export const deleteBookmark = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/bookmarks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteBookmarkMutationKey = () => ['deleteBookmark'] as const;

export const getDeleteBookmarkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,DeleteBookmarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,DeleteBookmarkMutationVariables, TContext> => {

const mutationKey = getDeleteBookmarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBookmark>>, DeleteBookmarkMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteBookmark(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBookmark>>>

    export type DeleteBookmarkMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteBookmarkMutationVariables = {id: string}

    /**
 * @summary Delete Bookmark
 */
export const useDeleteBookmark = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,DeleteBookmarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteBookmark>>,
        TError,
        DeleteBookmarkMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBookmarkMutationOptions(options), queryClient);
    }
